// extracted by mini-css-extract-plugin
module.exports = {"textInputLabel":"text-input-label-c05"};